module.exports = __webpack_public_path__ + "static/media/help_inventory.dc0ff192.png";